const ITEMS = [
  "BLACKWORK", "FINE LINE", "TRADITIONAL", "PROJETOS EXCLUSIVOS",
  "COBERTURA & REFORMA", "BIOSSEGURANÇA CERTIFICADA", "DUDU TATTOO STUDIO",
];

export const Marquee = () => {
  const content = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div className="relative overflow-hidden bg-[#121215]/90 border-y border-[#27272a] py-4" data-testid="editorial-marquee">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {content.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center font-mono-dt text-xs uppercase tracking-[0.3em] text-zinc-500">
                <span className="px-6">{item}</span>
                <span className="text-[#e03131]">•</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
